import { render, staticRenderFns } from "./ReservationBlock.vue?vue&type=template&id=77924d5e"
import script from "./ReservationBlock.vue?vue&type=script&lang=js"
export * from "./ReservationBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports